import {HDR_MAP_LOADER, loadHDRMap} from "./scene/HDRMapLoader";
import SceneModelsLoader from "./scene/SceneModelsLoader";
import store from "../../../../../../store";
import {setMultiLoader} from "../../../../../../actions/actionFunctions";
import Misc from "../../../../../../config";
import {isTouchDevice} from "../../../../../../misc/utils";

class SeparateModelGLBViewer {
  spinner = null;
  animationFrameId = null;
  lightIntensity = null;
  modelScale = 39.37;
  envMap = null;
  gltf = null;
  isMobile = false;
  modelLoader = null;
  modelsCenter = null;
  modelsSize = null;
  modelsLoaded = false;

  constructor(canvas, glbUrl, lightIntensity, isMobile) {
    this.canvas = canvas;
    this.glbUrl = glbUrl;
    this.lightIntensity = lightIntensity;
    this.isMobile = isMobile;

    // this.initSpinner();
    this.initScene();
    this.modelsLoader = new SceneModelsLoader(this, this.scene, this.modelScale);
  }

  initScene() {
    const isMobile = Misc.isMobile() || isTouchDevice();

    this.scene = new window.THREE.Scene();
    //this.scene.background = new window.THREE.Color(0xf0f0f0);
    //this.scene.background = new window.THREE.Color(0xbcc4ce);
    this.scene.background = new window.THREE.Color(0xcccccc);

    this.camera = new window.THREE.PerspectiveCamera(
      45,
      this.canvas.clientWidth / this.canvas.clientHeight,
      0.1,
      1000
    );
    this.camera.position.set(0, 0, 5);

    this.renderer = new window.THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      //antialias: !isMobile,
      preserveDrawingBuffer: true,
      powerPreference: isMobile ? "low-power" : "high-performance",
    });

    this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight);
    this.renderer.setPixelRatio(isMobile ? 1 : window.devicePixelRatio);
    this.renderer.outputColorSpace = window.THREE.SRGBColorSpace;
    this.renderer.useLegacyLights = false;
    this.renderer.toneMapping = window.THREE.ACESFilmicToneMapping;
    this.renderer.toneMappingExposure = 1;
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.autoUpdate = true;
    this.renderer.shadowMap.type = window.THREE.VSMShadowMap;
    this.renderer.gammaOutput = true;
    this.renderer.gammaFactor = 2.2;

    this.controls = new window.OrbitControls(this.camera, this.renderer.domElement);
    this.controls.target.set(0, 0, 0);
    this.controls.update();
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.1;
    this.controls.screenSpacePanning = true;
    this.controls.minDistance = 0.1;
    this.controls.maxDistance = 100;
    this.renderer.xr.enabled = true;

    const isIosDevice = navigator && (/iPad|iPhone/.test(navigator.userAgent));
    if (isMobile || isIosDevice) {
      // this.renderer.antialias = false;
      this.renderer.setPixelRatio(1);
      //this.renderer.setPixelRatio(0.5);
      this.renderer.powerPreference = "low-power";
      this.renderer.precision = "lowp";
      this.renderer.shadowMap.enabled = false;
      this.renderer.preserveDrawingBuffer = false;
      //this.renderer.toneMapping = window.THREE.NoToneMapping;
      this.renderer.toneMapping = window.THREE.NeutralToneMapping;
    } else {
      //loadHDRMap(this.scene, this.renderer, HDR_MAP_LOADER.pmremGeneratorEXR);
      loadHDRMap(this.scene, this.renderer, HDR_MAP_LOADER.rgb);
    }

    //const hdrBackgroundPath = "/images/sqft-icons/3d/comfy_cafe_1k.hdr"
    //this.loadHDRAsBackground(hdrBackgroundPath);
  }

  setBackgroundColor(hexColor) {
    this.scene.background = new window.THREE.Color(hexColor);
  }

  setModelsCenter = (modelsCenter) => {
    this.modelsCenter = modelsCenter
  }

  setModelsSize = (modelsCenter) => {
    this.modelsSize = modelsCenter
  }

  closeMultiLoader() {
    store.dispatch(setMultiLoader({ activeStep: 8 }));
    setTimeout(() => {
      store.dispatch(setMultiLoader({ visible: false }));
    }, 500);
  }

  calculateAndSetCameraPosition(center, size) {
    this.controls.reset();
    this.controls.target.copy(center);
    this.controls.maxDistance = size * 10;

    this.camera.position.copy(center.clone().add(new window.THREE.Vector3(size, size / 5, size * 2)));
    this.camera.near = size / 100;
    this.camera.far = size * 100;
    this.camera.lookAt(center);
    this.camera.updateProjectionMatrix();

    // if (this.controls) {
    //   this.controls.reset();
    //   this.controls.maxDistance = size * 10;
    // }
    //
    // if (this.camera) {
    //   this.camera.position.copy(center);
    //   this.camera.position.x += size; // far distance
    //   this.camera.position.y += size / 5.0;
    //   //this.camera.position.z += size;
    //   this.camera.position.z *= -1; // rotate distance
    //
    //   this.camera.near = size / 100;
    //   this.camera.far = size * 100;
    //   this.camera.updateProjectionMatrix();
    // }
  }

  addLight(boxCenter) {
    this.renderer.toneMappingExposure = 0.75;
    if (!boxCenter) {
      console.error("boxCenter is not defined");
      return;
    }

    const originalModelPosition = { x: -1.5, y: 0, z: -4.5 };
    const offsetX = boxCenter.x - originalModelPosition.x;
    const offsetZ = boxCenter.z - originalModelPosition.z;

    // 1. DirectionalLight (light_10)
    const dirLight1 = new window.THREE.DirectionalLight(0xffffff, 0.5);
    dirLight1.position.set(-1.135 + offsetX, 0.898, 5.486 + offsetZ);
    dirLight1.target = new window.THREE.Object3D();
    dirLight1.target.position.set(boxCenter.x, boxCenter.y, boxCenter.z);
    this.scene.add(dirLight1);
    this.scene.add(dirLight1.target);

    // 2. PointLight (1)
    const pointLight1 = new window.THREE.PointLight(0xffffff, 21.6, 0, 2);
    pointLight1.position.set(-3.317 + offsetX, 3.615, -2.885 + offsetZ);
    pointLight1.castShadow = true;
    this.scene.add(pointLight1);

    // 3. Второй DirectionalLight
    const dirLight2 = new window.THREE.DirectionalLight(0xffffff, 1);
    dirLight2.position.set(-6.846 + offsetX, 3.330, 3.781 + offsetZ);
    dirLight2.target = new window.THREE.Object3D();
    dirLight2.target.position.set(boxCenter.x, boxCenter.y, boxCenter.z);
    this.scene.add(dirLight2);
    this.scene.add(dirLight2.target);

    // 4. PointLight (2)
    const pointLight2 = new window.THREE.PointLight(0xffffff, 44, 6.36, 2);
    pointLight2.position.set(5.044 + offsetX, 0.540, -2.136 + offsetZ);
    pointLight2.castShadow = true;
    this.scene.add(pointLight2);

    // 5. PointLight (light_9)
    const pointLight3 = new window.THREE.PointLight(0xffffff, 7.96, 0, 2.24);
    pointLight3.position.set(-1.651 + offsetX, 2.851, -3.092 + offsetZ);
    pointLight3.castShadow = true;
    this.scene.add(pointLight3);
  }

  addLightOld(boxCenter) {
    //console.log("boxCenter", boxCenter);
    //const maxSize = Math.max(boxSize.x, boxSize.y, boxSize.z);
    const lightOffset = 4.5;
    const baseHeight = 2.5;

    const dynamicIntensity = this.lightIntensity ;

    //console.log(`maxSize: ${maxSize}, lightOffset: ${lightOffset}, baseHeight: ${baseHeight}`);
    console.log(`this.lightIntensity: ${this.lightIntensity }`);
    console.log(`dynamicIntensity: ${dynamicIntensity}`);

    const lightPositions = [
      // Central light
      { x: 0, y: baseHeight / 2, z: 5 },
      { x: 0, y: baseHeight * 2, z: 5 },

      // Upper corner Light
      { x: lightOffset, y: baseHeight, z: lightOffset },
      { x: -lightOffset, y: baseHeight, z: lightOffset },
      { x: lightOffset, y: baseHeight, z: -lightOffset },
      { x: -lightOffset, y: baseHeight, z: -lightOffset },

      // Bottom light
      { x: lightOffset, y: -baseHeight, z: lightOffset },
      { x: -lightOffset, y: -baseHeight, z: lightOffset },
      { x: lightOffset, y: -baseHeight, z: -lightOffset },
      { x: -lightOffset, y: -baseHeight, z: -lightOffset }
    ];


    lightPositions.forEach(pos => {
      let light = new window.THREE.PointLight(0xffffff, dynamicIntensity, 0, 2);
      light.position.set(boxCenter.x + pos.x, boxCenter.y + pos.y, boxCenter.z + pos.z);
      light.castShadow = true;
      this.scene.add(light);
      //console.log(`Light position: x: ${pos.x}, y: ${pos.y}, z: ${pos.z}, Intensity: ${dynamicIntensity}`);
    });

    // Добавление окружающего света для общего освещения
    const ambientLight = new window.THREE.AmbientLight(0xffffff, 0.1);
    this.scene.add(ambientLight);

    const directionalLight = new window.THREE.DirectionalLight(0xffffff, 0.8);
    directionalLight.position.set(boxCenter.x, boxCenter.y, boxCenter.z + 10);
    directionalLight.castShadow = true;
    this.scene.add(directionalLight);
  }

  addLightV9(boxCenter) {
    this.renderer.toneMappingExposure = 0.1;
    this.lightIntensity = 800;
    this.addLight(boxCenter);
  }

  addLightV10(boxCenter) {
    this.renderer.toneMappingExposure = 1;
    this.lightIntensity = 20;

    this.addLight(boxCenter);
  }

  updateSceneLighting(type) {
    // Delete current lights
    this.scene.children = this.scene.children.filter(child => !(child.isLight));

    // Create and add new light
    switch (type) {
      case 'addLightV9':
        this.addLightV9(this.modelsCenter);
        break;
      case 'addLightV10':
        this.addLightV10(this.modelsCenter);
        break;
      default:
        console.warn(`Unknown lighting type: ${type}`);
        break;
    }
  }

  updateLightIntensity(intensity) {
    this.lightIntensity = intensity
    this.scene.children.forEach(child => {
      if (child instanceof window.THREE.PointLight) {
        //console.log("child.intensity", child.intensity);
        child.intensity = intensity;
      }
    });
  }

  startAnimation() {
    const animate = () => {
      this.animationFrameId = requestAnimationFrame(animate);
      if (this.controls) {
        this.controls.update();
      }
      if (this.renderer) {
        this.renderer.render(this.scene, this.camera);
      }

    };

    animate();
  }

  stopAnimation() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

  dispose() {
    this.stopAnimation();
    this.scene.traverse((child) => {
      if (child.isMesh) {
        if (child.geometry) child.geometry.dispose();
        if (child.material) {
          if (Array.isArray(child.material)) {
            child.material.forEach((mat) => mat.dispose());
          } else {
            child.material.dispose();
          }
        }
      }
    });
    this.renderer.dispose();
    this.controls.dispose();

    // Remove spinner
    // if (this.spinner) {
    //   ReactDOM.unmountComponentAtNode(this.spinner);
    //   this.spinner.remove();
    //   this.spinner = null;
    // }

    // Nullify properties to free up memory
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.controls = null;
    this.canvas = null;
  }

  onMouseDown() {
  }

  onMouseMove() {
  }

  onMouseUp() {
  }

  onWheel() {
  }

  onWindowResize() {
    if (!this.canvas || !this.renderer || !this.camera) return;

    this.canvas.width = this.canvas.clientWidth;
    this.canvas.height = this.canvas.clientHeight;

    this.camera.aspect = this.canvas.clientWidth / this.canvas.clientHeight;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight, false);
    this.renderer.setPixelRatio(window.devicePixelRatio);
  }

  // This methods will rotate scene in case OrbitControls wont fit everything

  // onMouseDown(event) {
  //   this.mouseDown = true;
  //   this.lastPosition = {
  //     x: event.clientX,
  //     y: event.clientY
  //   };
  // }
  //
  // onMouseMove(event) {
  //   if (!this.mouseDown) return;
  //
  //   const deltaX = event.clientX - this.lastPosition.x;
  //   const deltaY = event.clientY - this.lastPosition.y;
  //
  //   this.camera.rotation.y += deltaX * 0.01;
  //   this.camera.rotation.x += deltaY * 0.01;
  //
  //   this.lastPosition = {
  //     x: event.clientX,
  //     y: event.clientY
  //   };
  //
  //   this.renderer.render(this.scene, this.camera);
  // }
  //
  // onMouseUp() {
  //   this.mouseDown = false;
  // }
  //
  // onWheel(event) {
  //   const delta = event.deltaY * 0.001;
  //   this.camera.position.z += delta;
  //
  //   this.renderer.render(this.scene, this.camera);
  // }
  // onWindowResize() {
  //
  // }
}

export default SeparateModelGLBViewer;
